module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/*****************
 ** WEBPACK FOOTER
 ** /code/~/core-js/library/modules/$.same.js
 ** module id = 825
 ** module chunks = 0
 **/